var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { AfterViewInit, ElementRef, EventEmitter, OnChanges, OnInit, SimpleChanges, ChangeDetectorRef } from '@angular/core';
import { Filters } from '../../classes/user-preferences';
import { HasSubscriptions } from '../has-subscriptions';
import { ListingCategory, SCREEN_SIZE, UpdatedSince } from '../../classes/enums';
import { SelectOption } from '../../components/forms/select/select.component';
import { Helper } from '../../classes/helper';
import { FormBuilder, FormGroup } from '@angular/forms';
import { debounceTime, take, skip } from 'rxjs/operators';
var FiltersComponent = /** @class */ (function (_super) {
    __extends(FiltersComponent, _super);
    function FiltersComponent(_preferencesService, communicationService, translateService, router, fb, cd) {
        var _this = _super.call(this) || this;
        _this._preferencesService = _preferencesService;
        _this.communicationService = communicationService;
        _this.translateService = translateService;
        _this.router = router;
        _this.fb = fb;
        _this.cd = cd;
        _this.onlyRentals = false;
        _this.onlyOpenHouses = false;
        _this.showAllPropTypes = true;
        _this.minPriceOptions = [];
        _this.maxPriceOptions = [];
        _this.bedOptions = [
            { text: 'Any', value: {} },
            { text: '1', value: { min: 1, max: 1 } },
            { text: '1+', value: { min: 1 } },
            { text: '2', value: { min: 2, max: 2 } },
            { text: '2+', value: { min: 2 } },
            { text: '3', value: { min: 3, max: 3 } },
            { text: '3+', value: { min: 3 } },
            { text: '4', value: { min: 4, max: 4 } },
            { text: '4+', value: { min: 4 } }
        ];
        _this.updatedSinceOptions = [
            { key: 'filters.updatedSince.default', value: UpdatedSince.ANY },
            { key: 'filters.updatedSince.yesterday', value: UpdatedSince.YESTERDAY },
            { key: 'filters.updatedSince.lastWeek', value: UpdatedSince.LASTWEEK },
            { key: 'filters.updatedSince.lastMonth', value: UpdatedSince.LASTMONTH },
        ];
        _this.bathOptions = [
            { text: 'Any', value: {} },
            { text: '1', value: { min: 1, max: 1 } },
            { text: '1+', value: { min: 1 } },
            { text: '2', value: { min: 2, max: 2 } },
            { text: '2+', value: { min: 2 } },
            { text: '3', value: { min: 3, max: 3 } },
            { text: '3+', value: { min: 3 } },
            { text: '4', value: { min: 4, max: 4 } },
            { text: '4+', value: { min: 4 } }
        ];
        _this.rentalValues = [
            0,
            100, 200, 300, 400, 500, 600, 700, 800, 900, 1000,
            1100, 1200, 1300, 1400, 1500, 1600, 1700, 1800, 1900, 2000,
            2100, 2200, 2300, 2400, 2500, 2600, 2700, 2800, 2900, 3000,
            3200, 3400, 3600, 3800, 4000,
            4200, 4400, 4600, 4800, 5000,
            6000, Number.MAX_SAFE_INTEGER // Show 6000+
        ];
        _this.lowerPriceValues = [
            25000, 50000, 75000
        ];
        _this.priceValues = [
            0, 25000, 50000, 75000, 100000,
            125000, 150000, 175000, 200000,
            225000, 250000, 275000, 300000,
            325000, 350000, 375000, 400000,
            425000, 450000, 475000, 500000,
            550000, 600000,
            650000, 700000,
            750000, 800000,
            850000, 900000,
            950000, 1000000,
            1100000, 1200000, 1300000, 1400000, 1500000,
            1600000, 1700000, 1800000, 1900000, 2000000,
            2500000, 3000000, 4000000, 5000000, 6000000, 7000000, 8000000, 9000000, 10000000, Number.MAX_SAFE_INTEGER //show $10M+
        ];
        _this.sizeValues = [
            0, 500, 550, 600, 650, 700, 750, 800, 850, 900, 950, 1000,
            1250, 1500, 1750, 2000,
            2250, 2500, 2750, 3000,
            3250, 3500, 3750, 4000,
            4250, 4500, 4750, 5000
        ];
        // Enums
        _this.SCREEN_SIZE = SCREEN_SIZE;
        _this.ListingCategory = ListingCategory;
        _this.filtersForm = _this.fb.group({
            listingTypes: _this.fb.group({
                house: false,
                condo: false,
                townhouse: false,
                recreational: false,
                farm: false,
                land: false,
                mobileHome: false
            }),
            beds: [{}],
            baths: [{}],
            updatedSince: [{}]
        });
        return _this;
    }
    FiltersComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.addSub(this.filtersForm.get('listingTypes').valueChanges.pipe(debounceTime(10)).subscribe(function (s) {
            // Added check for when open houses filter to turn off when all filter is clicked
            if (_this.onlyRentals && Object.keys(s).some(function (k) { return s[k]; }))
                _this.toggleRentals(false);
            if (_this.onlyOpenHouses && Object.keys(s).some(function (k) { return s[k]; }))
                _this.toggleOpenHouses(false);
            if (!_this.onlyRentals && !_this.onlyOpenHouses && Object.keys(s).every(function (k) { return !s[k]; }))
                _this.showAllPropTypes = true;
            else
                _this.showAllPropTypes = false;
        }));
        this.filtersForm.addControl('minPrice', this.fb.control(0));
        this.filtersForm.addControl('maxPrice', this.fb.control(0));
        this.filtersForm.controls['updatedSince'].setValue(UpdatedSince.ANY);
        this.addSub(this.communicationService.screenSize.subscribe(function (s) { return _this.screenSize = s; }));
        // NOTE: should we skip 1 here because the currentShownListingType is a behavior subject
        this.addSub(this.communicationService.listings.currentShownListingType.subscribe(function (c) {
            _this._resetForm();
            _this.currentShownListingType = c;
            _this.SetPriceFilters();
        }));
        this._preferencesService.filtersChanged.pipe(take(1)).toPromise().then(function (filters) { return _this._updateFiltersForm(filters); });
        this.addSub(this.filtersForm.get('minPrice').valueChanges.subscribe(function (s) { return _this.updateMaxPriceOptions(); }));
    };
    FiltersComponent.prototype.SetPriceFilters = function () {
        var _this = this;
        this.filteredPriceValues = this.currentShownListingType === ListingCategory.LUXURY ?
            this.priceValues.filter(function (value) { return _this.lowerPriceValues.indexOf(value) === -1; }) : this.priceValues;
        this.minPriceOptions = this.filteredPriceValues.map(function (value) { return new SelectOption('$' + Helper.formatPrice(value), value); });
        this.maxPriceOptions = this.filteredPriceValues.map(function (value) { return new SelectOption('$' + Helper.formatPrice(value), value); });
        // No need for $10M+ in min price filter
        this.minPriceOptions.splice(-1, 1);
        // Add $3M+ in max price filter
        this.maxPriceOptions[this.maxPriceOptions.length - 1].text = this.maxPriceOptions[this.maxPriceOptions.length - 2].text + '+';
        this.minPriceOptions[0].key = 'filters.no-min';
        this.maxPriceOptions[0].key = 'filters.no-max';
    };
    FiltersComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        // Skipping this broadcast the first time the component is enabled. We only want to broadcast future changes.
        // It's in afterViewInit to make sure it doesn't get fired while the form is being set up.
        this.addSub(this.filtersForm.valueChanges.pipe(debounceTime(10)).pipe(skip(1)).subscribe(function (s) {
            _this.broadcastChangedFilters();
        }));
        this.addSub(this.communicationService.filters.resetAndUpdatePropType.subscribe(function (newPropType) {
            // HACK: Dont know why I need the timeout here, but apparently it works
            setTimeout(function () {
                _this._resetForm();
                _this.listingTypesFg.controls[newPropType].setValue(true);
                _this.broadcastChangedFilters();
            });
        }));
    };
    // TODO: Currently a bug when you switch to rentals, or back, the price/rental price changes but it screws up the values on the slider
    FiltersComponent.prototype.ngOnChanges = function (changes) { };
    FiltersComponent.prototype.onReset = function () {
        this._resetForm();
        this.onlyRentals = false;
        this.onlyOpenHouses = false;
        this.broadcastChangedFilters();
    };
    FiltersComponent.prototype.clearListingTypes = function (setRentalFalse) {
        this.listingTypesFg.setValue({
            house: false,
            condo: false,
            townhouse: false,
            recreational: false,
            farm: false,
            land: false,
            mobileHome: false
        });
        if (setRentalFalse) {
            this.onlyRentals = false;
            this.onlyOpenHouses = false;
        }
    };
    FiltersComponent.prototype.broadcastChangedFilters = function () {
        var value = Object.assign(new Filters(), this.filtersForm.value);
        value.rentalsOnly = this.onlyRentals;
        value.hasOpenHouse = this.onlyOpenHouses;
        this._preferencesService.updateFilters(value);
        this.communicationService.searchParametersChanged.next();
    };
    FiltersComponent.prototype.toMagnitudes = function (parseAsPrice) {
        if (parseAsPrice === void 0) { parseAsPrice = false; }
        return parseAsPrice ? Helper.toDollarMagnitudes : Helper.toMagnitudes;
    };
    FiltersComponent.prototype.compareWithHasMinMax = function (item1, item2) {
        return Helper.compareWithHasMinMax(item1, item2);
    };
    Object.defineProperty(FiltersComponent.prototype, "listingTypesFg", {
        get: function () {
            return this.filtersForm.get('listingTypes');
        },
        enumerable: true,
        configurable: true
    });
    // If rentals are allowed, untoggle all listings and property types
    // if rentals not allowed, dont do anything
    FiltersComponent.prototype.toggleRentals = function (newCheckedValue) {
        this.filtersForm.patchValue({ price: {} });
        this.onlyRentals = newCheckedValue;
        // Turn off open houses filter when the rentals filter is on
        this.onlyOpenHouses = false;
        if (this.onlyRentals)
            this.clearListingTypes(false);
    };
    /**
     * Whether to only show listings that have an open house
     */
    FiltersComponent.prototype.toggleOpenHouses = function (newCheckedValue) {
        this.onlyOpenHouses = newCheckedValue;
        // Turn off rentals filter when open house is toggled on
        this.onlyRentals = false;
        if (this.onlyOpenHouses)
            this.clearListingTypes(false);
        this.broadcastChangedFilters();
    };
    // let the child figure out what to update
    FiltersComponent.prototype._updateFiltersForm = function (filters) {
        this.onlyRentals = filters.rentalsOnly;
        this.onlyOpenHouses = filters.hasOpenHouse;
        this.showAllPropTypes = !this.onlyRentals && !this.onlyOpenHouses;
        this.filtersForm.patchValue({
            listingTypes: {
                house: filters.listingTypes.house,
                condo: filters.listingTypes.condo,
                townhouse: filters.listingTypes.townhouse,
                recreational: filters.listingTypes.recreational,
                farm: filters.listingTypes.farm,
                land: filters.listingTypes.land,
                mobileHome: filters.listingTypes.mobileHome,
            },
            beds: filters.beds || {},
            baths: filters.baths || {},
            updatedSince: !filters.updatedSince ? UpdatedSince.ANY : filters.updatedSince
        });
    };
    FiltersComponent.prototype._resetForm = function () {
        this.filtersForm.patchValue({
            listingTypes: {
                house: false,
                condo: false,
                townhouse: false,
                recreational: false,
                farm: false,
                land: false,
                mobileHome: false
            },
            beds: {},
            baths: {},
            stories: {},
            businessTypes: {},
            updatedSince: UpdatedSince.ANY
        });
    };
    FiltersComponent.prototype.updateMaxPriceOptions = function () {
        var minValue = this.filtersForm.controls['minPrice'].value;
        var maxValue = this.filtersForm.controls['maxPrice'].value;
        // Reset the max value in case the min value is greater
        if (minValue > maxValue) {
            this.filtersForm.controls['maxPrice'].setValue(0);
        }
        // Disable the max options if the min value is greater than the option
        this.maxPriceOptions.forEach(function (option) {
            option.disabled = minValue > option.value && option.value !== 0;
            return option;
        });
        this.cd.detectChanges();
    };
    return FiltersComponent;
}(HasSubscriptions));
export { FiltersComponent };
var FiltersDesktopComponent = /** @class */ (function (_super) {
    __extends(FiltersDesktopComponent, _super);
    function FiltersDesktopComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.showPropertyTypes = false;
        _this.showPrice = false;
        _this.showBedrooms = false;
        _this.showMore = false;
        _this.showSize = false;
        _this.minRentalPriceOptions = [];
        _this.maxRentalPriceOptions = [];
        _this.minSizeOptions = [];
        _this.maxSizeOptions = [];
        return _this;
    }
    FiltersDesktopComponent.prototype.ngOnInit = function () {
        var _this = this;
        _super.prototype.ngOnInit.call(this);
        this.filtersForm.addControl('minSize', this.fb.control(0));
        this.filtersForm.addControl('maxSize', this.fb.control(0));
        this.filtersForm.controls['updatedSince'].setValue(UpdatedSince.ANY);
        this.minRentalPriceOptions = this.rentalValues.map(function (value) { return new SelectOption('$' + Helper.formatPrice(value, 10000), value); });
        this.maxRentalPriceOptions = this.rentalValues.map(function (value) { return new SelectOption('$' + Helper.formatPrice(value, 10000), value); });
        // No need for $6000+ in min rental price filter
        this.minRentalPriceOptions.splice(-1, 1);
        // Add $6000+ in max rental price filter
        this.maxRentalPriceOptions[this.maxRentalPriceOptions.length - 1].text = this.maxRentalPriceOptions[this.maxRentalPriceOptions.length - 2].text + '+';
        this.minSizeOptions = this.sizeValues.map(function (value) { return new SelectOption(value, value); });
        this.maxSizeOptions = this.sizeValues.map(function (value) { return new SelectOption(value, value); });
        // TODO: Translations
        this.minRentalPriceOptions[0].text = 'No Min';
        this.maxRentalPriceOptions[0].text = 'No Max';
        this.minSizeOptions[0].text = 'No Min';
        this.maxSizeOptions[0].text = 'No Max';
        this.addSub(this.filtersForm.get('minSize').valueChanges.subscribe(function (s) { return _this.updateMaxSizeOptions(); }));
        // TODO: Translations
        this.bathOptions.forEach(function (option) { return option.text = option.text + ' Baths'; });
        this.bedOptions.forEach(function (option) { return option.text = option.text + ' Beds'; });
    };
    FiltersDesktopComponent.prototype.onPageClick = function ($event) {
        // Hide all the dropdowns if the dropdowns are open and they click something not a dropdown
        if (!this.formElementRef.nativeElement.contains($event.target))
            this.closeDropdowns();
    };
    FiltersDesktopComponent.prototype.updateMaxSizeOptions = function () {
        var minValue = this.filtersForm.get('minSize').value;
        // Reset the max value in case the min value is greater
        if (minValue > this.filtersForm.get('maxSize').value)
            this.filtersForm.get('maxSize').setValue(0);
        // Disable the max options if the min value is greater than the option
        this.maxSizeOptions = this.maxSizeOptions.map(function (option) {
            if (minValue > option.value && option.value !== 0)
                option.disabled = true;
            else
                option.disabled = false;
            return option;
        });
        this.cd.detectChanges();
    };
    FiltersDesktopComponent.prototype.broadcastChangedFilters = function () {
        var value = Object.assign(new Filters(), this.filtersForm.value);
        value.price = {
            min: this.filtersForm.get('minPrice').value,
            max: this.filtersForm.get('maxPrice').value
        };
        value.size = {
            min: this.filtersForm.get('minSize').value,
            max: this.filtersForm.get('maxSize').value
        };
        value.rentalsOnly = this.onlyRentals;
        value.hasOpenHouse = this.onlyOpenHouses;
        this._preferencesService.updateFilters(value);
        this.communicationService.searchParametersChanged.next();
    };
    FiltersDesktopComponent.prototype.onSubmit = function () {
        this.closeDropdowns();
    };
    FiltersDesktopComponent.prototype.checkFocus = function (event, parentElement, elementToFocus) {
        if (!parentElement.contains(event.target)) {
            this.closeDropdowns(null, null, elementToFocus);
        }
    };
    /**
     * Close all dropdowns, and set the status of one dropdown to the desired status
     * @param dropdownName dropdownName we want to specifically toggle
     * @param newStatus the new status
     */
    FiltersDesktopComponent.prototype.closeDropdowns = function (dropdownName, newStatus, elementToFocus) {
        this.showPropertyTypes = false;
        this.showPrice = false;
        this.showBedrooms = false;
        this.showMore = false;
        this.showSize = false;
        if (dropdownName)
            this[dropdownName] = newStatus;
        if (!!elementToFocus)
            elementToFocus.focus();
    };
    FiltersDesktopComponent.prototype.onReset = function () {
        _super.prototype.onReset.call(this);
        this.closeDropdowns();
    };
    FiltersDesktopComponent.prototype.toggleRentals = function (newCheckedValue) {
        _super.prototype.toggleRentals.call(this, newCheckedValue);
        this.filtersForm.patchValue({
            minPrice: 0,
            maxPrice: 0
        });
    };
    FiltersDesktopComponent.prototype._updateFiltersForm = function (filters) {
        _super.prototype._updateFiltersForm.call(this, filters);
        this.filtersForm.patchValue({
            minPrice: filters.price && filters.price.min ? filters.price.min : 0,
            maxPrice: filters.price && filters.price.max ? filters.price.max : 0,
            minSize: filters.size && filters.size.min ? filters.size.min : 0,
            maxSize: filters.size && filters.size.max ? filters.size.max : 0
        });
    };
    FiltersDesktopComponent.prototype._resetForm = function () {
        _super.prototype._resetForm.call(this);
        this.filtersForm.patchValue({
            minSize: 0,
            maxSize: 0,
            minPrice: 0,
            maxPrice: 0
        });
    };
    Object.defineProperty(FiltersDesktopComponent.prototype, "priceText", {
        get: function () {
            var minPrice = this.filtersForm.get('minPrice').value;
            var maxPrice = this.filtersForm.get('maxPrice').value;
            // TODO: Translations
            if (minPrice === 0 && maxPrice === 0)
                return 'Any Price';
            else if ((minPrice > 0 && maxPrice === 0) || (maxPrice === Number.MAX_SAFE_INTEGER))
                return Helper.toDollarMagnitudes(minPrice) + '+';
            else if (minPrice === 0 && maxPrice > 0)
                return Helper.toDollarMagnitudes(0) + ' - ' + Helper.toDollarMagnitudes(maxPrice);
            else
                return Helper.toDollarMagnitudes(minPrice) + ' - ' + Helper.toDollarMagnitudes(maxPrice);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FiltersDesktopComponent.prototype, "sizeText", {
        get: function () {
            var minSize = this.filtersForm.get('minSize').value;
            var maxSize = this.filtersForm.get('maxSize').value;
            // TODO: translations
            if (!minSize && !maxSize)
                return 'Any Square Feet';
            else if (minSize && !maxSize)
                return Helper.toMagnitudes(minSize) + '+ sqft';
            else if (!minSize && maxSize)
                return Helper.toMagnitudes(0) + ' - ' + Helper.toMagnitudes(maxSize) + '+ sqft';
            else
                return Helper.toMagnitudes(minSize) + ' - ' + Helper.toMagnitudes(maxSize) + ' sqft';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FiltersDesktopComponent.prototype, "propertyText", {
        get: function () {
            var _this = this;
            var totalPropsEnabled = Object.keys(this.listingTypesFg.value).filter(function (key) { return _this.listingTypesFg.value[key]; }).length;
            // TODO: Translations
            if (this.onlyRentals)
                return 'All Rentals';
            if (this.onlyOpenHouses)
                return 'All Open Houses';
            return totalPropsEnabled > 0 ? "Property Types (" + totalPropsEnabled + ")" : 'All Property Types';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FiltersDesktopComponent.prototype, "moreText", {
        get: function () {
            var totalExtraValuesEnabled = 0;
            if (this.filtersForm.get('minSize').value || this.filtersForm.get('maxSize').value)
                totalExtraValuesEnabled++;
            if (this.filtersForm.get('baths').value && (this.filtersForm.get('baths').value.min || this.filtersForm.get('baths').value.max))
                totalExtraValuesEnabled++;
            if (this.filtersForm.get('beds').value && (this.filtersForm.get('beds').value.min || this.filtersForm.get('beds').value.max))
                totalExtraValuesEnabled++;
            if (this.filtersForm.get('updatedSince').value && this.filtersForm.get('updatedSince').value !== UpdatedSince.ANY)
                totalExtraValuesEnabled++;
            return 'More' + (totalExtraValuesEnabled > 0 ? " (" + totalExtraValuesEnabled + ")" : '');
        },
        enumerable: true,
        configurable: true
    });
    return FiltersDesktopComponent;
}(FiltersComponent));
export { FiltersDesktopComponent };
var FiltersMobileComponent = /** @class */ (function (_super) {
    __extends(FiltersMobileComponent, _super);
    function FiltersMobileComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.closed = new EventEmitter();
        return _this;
    }
    FiltersMobileComponent.prototype.ngOnInit = function () {
        var _this = this;
        _super.prototype.ngOnInit.call(this);
        this.filtersForm.addControl('size', this.fb.control({}));
        this.filtersForm.addControl('price', this.fb.control({}));
        this.addSub(this.communicationService.searchResultsAvailable.subscribe(function (results) {
            _this.listingsAvailable = results;
            var drawerTitleRightText = _this.translateService.instant('filters.n-results', { n: results });
            document.querySelector('app-drawer .drawer-sub-title-right').innerHTML = drawerTitleRightText;
        }));
    };
    FiltersMobileComponent.prototype.onSubmit = function () {
        this.closed.emit();
        // TODO: Changing the location doesnt do anything here
    };
    FiltersMobileComponent.prototype._updateFiltersForm = function (filters) {
        _super.prototype._updateFiltersForm.call(this, filters);
        this.filtersForm.patchValue({
            size: filters.size,
            price: filters.price
        });
    };
    FiltersMobileComponent.prototype._resetForm = function () {
        _super.prototype._resetForm.call(this);
        this.filtersForm.patchValue({
            size: {},
            price: {}
        });
    };
    return FiltersMobileComponent;
}(FiltersComponent));
export { FiltersMobileComponent };
